"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const s = ({
  title: r,
  titleId: i,
  desc: n,
  descId: o,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...t,
    children: [
      n ? /* @__PURE__ */ e("desc", { id: o, children: n }) : null,
      r ? /* @__PURE__ */ e("title", { id: i, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "m20 20-3.8667-3.8667m2.0889-5.0222c0 3.9274-3.1837 7.1111-7.1111 7.1111S4 15.0385 4 11.1111 7.1838 4 11.1111 4s7.1111 3.1838 7.1111 7.1111"
        }
      )
    ]
  }
);
export {
  s as default
};
//# sourceMappingURL=SearchOutlined.js.map
